<template>
  <article class="transaction-chart card">
    <ChartHeader
      v-model="selected"
      :price="coin.formated"
      :intervals="intervals"
      />

    <ApexChart class="transaction-chart__chart" width="100%" height="420" type="area" :options="options" :series="series" />
  </article>
</template>

<script>
  import ApexChart from 'vue-apexcharts';
  import { format, createChartArray } from '@/helpers';
  import { mapState, mapGetters, mapMutations } from 'vuex';
  import ChartHeader from '@/components/Transaction/Chart/Header';

  export default {
    components: {
      ApexChart,
      ChartHeader,
    },

    data: () => ({
      selected: '24H',
      values: [[0, 0]],
    }),

    watch: {
      coin: 'fetchValues',
      selected: 'fetchValues',
    },

    mounted () {
      this.fetchValues();
    },

    methods: {
      async fetchValues () {
        this.values = await createChartArray(this.coin.total, ...this.interval);
      },
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),

      prices () {
        return this.series[0].data.map(([, value]) => value);
      },

      interval () {
        return this.intervals[this.selected];
      },

      intervals () {
        return {
          '1H': [
            60, 60 * 1000, 100000,
          ],

          '24H': [
            48, 30 * 60 * 1000, 10000,
          ],

          '1S': [
            56, 3 * 60 * 60 * 1000, 1000,
          ],

          '1A': [
            24, 12 * 30 * 60 * 60 * 1000, 500,
          ],

          'MAX': [
            48, 12 * 30 * 60 * 60 * 1000, 100,
          ],
        };
      },

      series () {
        return [{
          data: this.values,
        }];
      },

      options () {
        const max = Math.max(...this.prices);
        const base = max / 100;
        const min = Math.max(Math.min(...this.prices) - base, 0);

        return {
          chart: {
            toolbar: {
              show: false,
            },

            stacked: true,

            zoom: {
              enabled: false,
            },

            animations: {
              enabled: false,
            },
          },

          legend: {
            show: false,
            enabled: false,
          },

          dataLabels: {
            enabled: false,
          },

          markers: {
            size: 0,
            colors: [
              this.coin.color,
            ],
            strokeWidth: 10,
            strokeOpacity: 0.2,
            strokeColor: this.coin.color,
            hover: {
              size: 5,
            },
          },

          grid: {
            borderColor: 'rgba(255, 255, 255, 0.08)',
            padding: {
              top: 0,
              right: 5,
              left: 15,
              bottom: 26,
            },
          },

          stroke: {
            width: 2.5,
            colors: [
              this.coin.color,
            ],
            curve: 'straight',
          },

          tooltip: {
            theme: false,

            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const price = format(series[seriesIndex][dataPointIndex]);
              const day = new Date(this.series[0].data[dataPointIndex][0]);

              return `<div class="chart-crypto__label"><span class="chart-crypto__price">${price}</span> ${day.toLocaleString('pt-BR')}</div>`;
            },
          },

          fill: {
            colors: [
              this.coin.color,
            ],

            gradient: {
              colorStops: [
                {
                  offset: 0,
                  opacity: .3,
                  color: this.coin.color,
                },
                {
                  offset: 100,
                  opacity: 0,
                  color: this.coin.color,
                },
              ],
            },
          },

          yaxis: {
            min,
            max: max + base,
            decimalsInFloat: 0,
            forceNiceScale: true,

            labels: {
              style: {
                cssClass: 'transaction-chart__label',
              },
            },
          },

          xaxis: {
            type: 'datetime',

            labels: {
              offsetY: 5,

              style: {
                cssClass: 'transaction-chart__label transaction-chart__label--x',
              },

              datetimeFormatter: {
                year: 'MM / yyyy',
                month: "MM / yyyy",
                day: 'dd / MM',
                hour: 'HH:mm',
              },
            },

            axisBorder: {
              color: 'rgba(255, 255, 255, 0.08)',
            },

            axisTicks: {
              height: 8,
              offsetY: 8,
              color: 'rgba(255, 255, 255, 0.3)',
            },

            tooltip: {
              enabled: false,
            },
          },
        };
      },
    },
  };
</script>

<style lang="scss">
  .transaction-chart {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__label {
      fill: #b2b8c5;
      font-size: 13px;
      font-family: Rubik;
      letter-spacing: 0.26px;
    }

    &__chart {
      padding: 0 24px 0 12px;
    }
  }
</style>
